const STUDY_MANIFEST_ID = 'study-pwa-manifest';
const STUDY_SCOPE_PREFIX = '/estudar';
const STUDY_SW_URL = '/study-sw.js';
const STUDY_SW_SCOPE = '/estudar';

let registrationPromise = null;

export function syncStudyPwa(routePath) {
  if (isStudyRoute(routePath)) {
    ensureStudyManifest();
    registerStudyServiceWorker();
  } else {
    removeStudyManifest();
  }
}

export function registerStudyServiceWorker() {
  if (!('serviceWorker' in navigator)) return Promise.resolve(null);
  if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
    return Promise.resolve(null);
  }

  if (!registrationPromise) {
    registrationPromise = registrarStudyServiceWorker()
      .catch((error) => {
        registrationPromise = null;
        console.error('Erro ao registrar PWA de estudos:', error);
        return null;
      });
  }

  return registrationPromise;
}

function isStudyRoute(routePath) {
  return routePath === STUDY_SCOPE_PREFIX || routePath.startsWith(`${STUDY_SCOPE_PREFIX}/`);
}

function ensureStudyManifest() {
  if (document.getElementById(STUDY_MANIFEST_ID)) return;

  const manifest = document.createElement('link');
  manifest.id = STUDY_MANIFEST_ID;
  manifest.rel = 'manifest';
  manifest.href = '/study-pwa.webmanifest';
  document.head.appendChild(manifest);

  setMetaThemeColor('#561631');
}

function removeStudyManifest() {
  const manifest = document.getElementById(STUDY_MANIFEST_ID);
  if (manifest) {
    manifest.remove();
  }
}

function setMetaThemeColor(color) {
  let themeColor = document.querySelector('meta[name="theme-color"]');
  if (!themeColor) {
    themeColor = document.createElement('meta');
    themeColor.setAttribute('name', 'theme-color');
    document.head.appendChild(themeColor);
  }
  themeColor.setAttribute('content', color);
}

async function registrarStudyServiceWorker() {
  await removerRegistrosStudyQuebrados();

  const registration = await registrarStudyServiceWorkerBase();

  try {
    await registration.update();
    return registration;
  } catch (error) {
    if (!isServiceWorkerNotFoundError(error)) {
      throw error;
    }

    await registration.unregister();
    return registrarStudyServiceWorkerBase();
  }
}

function registrarStudyServiceWorkerBase() {
  return navigator.serviceWorker.register(STUDY_SW_URL, {
    scope: STUDY_SW_SCOPE,
    updateViaCache: 'none',
  });
}

async function removerRegistrosStudyQuebrados() {
  const registrations = await navigator.serviceWorker.getRegistrations();

  await Promise.all(
    registrations
      .filter((registration) => isStudyScope(registration.scope) && isRegistroStudyQuebrado(registration))
      .map((registration) => registration.unregister())
  );
}

function isStudyScope(scope) {
  const pathname = new URL(scope).pathname.replace(/\/$/, '');
  return pathname === STUDY_SCOPE_PREFIX;
}

function isRegistroStudyQuebrado(registration) {
  const worker = registration.installing || registration.waiting || registration.active;
  if (!worker?.scriptURL) return true;

  const scriptPath = new URL(worker.scriptURL).pathname;
  return scriptPath !== STUDY_SW_URL;
}

function isServiceWorkerNotFoundError(error) {
  return error?.name === 'TypeError' && String(error.message || '').includes('Not found');
}
